import { verify } from "jsonwebtoken";

export const decodeAnswer = (token) => {
    token = Buffer.from(token, 'base64').toString('utf8');
    return verify(token, process.env.REACT_APP_JWT_SECRET);
};
